<div class="modal-header">
    <h5 class="modal-title">Export Goals</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    <p class="mb-3">Choose how to export the grid:</p>
    <div class="mb-3">
        <button type="button" class="btn btn-primary w-100 mb-2" (click)="exportAll()">Export all columns</button>
        <p class="text-muted small mb-2">Export the entire grid including all week columns.</p>
    </div>
    <hr />
    <p class="mb-2">Or export only week columns within a date range:</p>
    <div class="row g-2 mb-3">
        <div class="col-md-6">
            <label class="form-label" for="goals-export-start-date">Start date</label>
            <wj-input-date id="goals-export-start-date" [(ngModel)]="startDate" [isRequired]="false"></wj-input-date>
        </div>
        <div class="col-md-6">
            <label class="form-label" for="goals-export-end-date">End date</label>
            <wj-input-date id="goals-export-end-date" [(ngModel)]="endDate" [isRequired]="false"></wj-input-date>
        </div>
    </div>
    <button type="button" class="btn btn-secondary mb-3" (click)="exportRange()">Export date range</button>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
</div>
